// LensOutlet shared JS — nav, cart, order forms
(function(){
  'use strict';

  // ============ NAV ============
  document.addEventListener('DOMContentLoaded', function(){
    var mt = document.getElementById('menuToggle');
    if(mt) mt.addEventListener('click', function(){
      document.getElementById('mainNav').classList.toggle('open');
    });

    document.querySelectorAll('nav.main > ul > li').forEach(function(li){
      var link = li.querySelector('a');
      var dd = li.querySelector('.dropdown');
      if(!dd) return;
      link.addEventListener('click', function(e){
        if(window.innerWidth < 900){
          e.preventDefault();
          document.querySelectorAll('nav.main > ul > li.open').forEach(function(o){
            if(o !== li) o.classList.remove('open');
          });
          li.classList.toggle('open');
        }
      });
    });

    // cart badge is rendered server-side via {{ cart.item_count }} (Shopify cart); no JS override
  });

  // ============ CART ============
  function getCart(){
    try { return JSON.parse(localStorage.getItem('loCart')||'[]'); }
    catch(e){ return []; }
  }
  function setCart(c){
    localStorage.setItem('loCart', JSON.stringify(c));
    updateCartCount();
  }
  function updateCartCount(){
    var c = getCart();
    var n = c.reduce(function(a,i){return a+(i.qty||1);},0);
    document.querySelectorAll('#cartCount,.cart-count').forEach(function(el){ el.textContent = n; });
  }
  window.LO_addToCart = function(item){
    var c = getCart();
    c.push(item);
    setCart(c);
    showToast('Added to cart');
  };
  window.LO_getCart = getCart;
  window.LO_setCart = setCart;
  window.LO_removeFromCart = function(idx){
    var c = getCart();
    c.splice(idx, 1);
    setCart(c);
  };
  window.LO_clearCart = function(){
    setCart([]);
  };

  function showToast(msg){
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;bottom:30px;right:30px;background:#0F2046;color:#fff;padding:14px 22px;font-size:14px;font-weight:600;z-index:9999;box-shadow:0 6px 24px rgba(0,0,0,.2);border-left:4px solid #1E5BD9;animation:slideIn .3s ease';
    document.body.appendChild(t);
    setTimeout(function(){ t.style.opacity='0'; t.style.transition='opacity .3s'; }, 1800);
    setTimeout(function(){ t.remove(); }, 2200);
  }
  window.LO_toast = showToast;

  // ============ RX MATERIAL LIST ============
  window.LO_MATERIALS = [
    {g:'CR-39 Single Vision', opts:[
      ['CR-39 SV', 9.99],['CR-39 SV Photo',24.99],['CR-39 SV Polarized',34.99]
    ]},
    {g:'CR-39 Progressive', opts:[
      ['CR-39 Digital Progressive',14.99],['CR-39 Digital Progressive Photo',44.99],['CR-39 Digital Progressive Polarized',69.99]
    ]},
    {g:'CR-39 / 1.56 Bifocal', opts:[
      ['1.56 FT28',14.99],['1.56 FT28 Photo',39.99],['CR-39 FT28 Polarized',89.99]
    ]},
    {g:'Polycarbonate Single Vision', opts:[
      ['Poly SV',29.99],['Poly SV Photo',49.99],['Poly SV Polarized',64.99]
    ]},
    {g:'Polycarbonate Progressive', opts:[
      ['Poly Digital Progressive',39.99],['Poly Digital Progressive Photo',69.99],['Poly Digital Progressive Polarized',99.99]
    ]},
    {g:'Polycarbonate Bifocal FT28', opts:[
      ['Poly FT28',39.99],['Poly FT28 Photo',59.99],['Poly FT28 (blended) Polarized',129.99]
    ]},
    {g:'1.67 Hi-Index Single Vision', opts:[
      ['1.67 SV',44.99],['1.67 SV Photo',69.99],['1.67 SV Polarized',89.99]
    ]},
    {g:'1.67 Hi-Index Progressive', opts:[
      ['1.67 Digital Progressive',69.99],['1.67 Digital Progressive Photo',119.99],['1.67 Digital Progressive Polarized',149.99]
    ]},
    {g:'1.67 Hi-Index Bifocal FT28', opts:[
      ['1.67 FT28',119.99],['1.67 FT28 Photo',149.99]
    ]},
    {g:'1.74 Hi-Index Progressive', opts:[
      ['1.74 Digital Progressive',139.99],['1.74 Digital Progressive Photo',169.99]
    ]},
    {g:'Essilor / Varilux (quote)', opts:[
      ['CR-39 SV Essilor Brand',0],['Poly SV Essilor Brand',0],['1.67 SV Essilor Brand',0],
      ['CR-39 Varilux Comfort DRX',0],['Poly Varilux Comfort DRX',0],['1.67 Varilux Comfort DRX',0]
    ]}
  ];

  window.LO_AR = [
    ['No AR',0],['Standard AR',9.99],['Super Hydrophobic AR',14.99],
    ['Platinum Anti-Glare (quote, Essilor only)',0],
    ['Crizal Easy Pro (quote)',0],['Crizal Rock (quote)',0],
    ['Crizal Sapphire (quote)',0],['Crizal Prevencia (quote)',0]
  ];

  window.LO_UPGRADES = [
    ['No Upgrade',0],
    ['Premium Digital Upgrade',25.00],
    ['Mirror Coating',25.00]
  ];

  window.LO_TINT = [
    ['No Tint',0],
    ['Solid Tint',8.00],
    ['Gradient Tint',10.00],
    ['Double Gradient Tint (quote)',0],
    ['Match Tint (quote)',0],
    ['Smart Blue Filter',19.99]
  ];

  window.LO_TRANSITIONS = [
    ['No Transitions',0],
    ['Photochromic — Grey or Brown (quote)',0],
    ['Essilor Transitions Gen S (quote)',0],
    ['Transitions Extra Active / XActive (quote)',0],
    ['Transitions Vantage (quote)',0]
  ];

  window.LO_TINT_COLOR = [
    ['No Color',0],
    ['Grey',0],['Green',0],['Brown',0],['Yellow',0],
    ['Blue',0],['Purple',0],['Rose',0],['Pink',0]
  ];

  // ============ STOCK LENS CATALOG ============
  window.LO_STOCK = [
    {g:'CR-39 (1.49) — Uncoated & Coated', items:[
      ['CR-39 Uncoated 65/70mm','+6.00 to -6.00','0.00 to -2.00',0.59],
      ['CR-39 Uncoated EXT 65/70mm','+6.00 to -6.00','-2.25 to -4.00',1.29],
      ['CR-39/1.56 AR','+6.00 to -6.00','0.00 to -2.00',2.25],
      ['CR-39/1.56 AR EXT','+6.00 to -6.00','-2.25 to -4.00',3.69]
    ]},
    {g:'1.56 — Blue Blocker AR', items:[
      ['1.56 Blue Blocker AR','+6.00 to -6.00','0.00 to -2.00',4.99],
      ['1.56 Blue Blocker AR EXT','+6.00 to -6.00','0.00 to -4.00',5.69]
    ]},
    {g:'1.56 — Photochromic (Grey)', items:[
      ['1.56 Photo Grey','+6.00 to -6.00','0.00 to -2.00',8.59],
      ['1.56 Photo Grey EXT','+6.00 to -6.00','0.00 to -4.00',10.99],
      ['1.56 Photo Grey AR','+6.00 to -6.00','0.00 to -2.00',14.59],
      ['1.56 Photo Grey AR EXT','+6.00 to -6.00','0.00 to -4.00',16.99]
    ]},
    {g:'1.56 — Photochromic (Brown)', items:[
      ['1.56 Photo Brown','+6.00 to -6.00','0.00 to -2.00',14.59],
      ['1.56 Photo Brown EXT','+6.00 to -6.00','0.00 to -4.00',10.99],
      ['1.56 Photo Brown AR','+6.00 to -6.00','0.00 to -2.00',16.59],
      ['1.56 Photo Brown AR EXT','+6.00 to -6.00','0.00 to -4.00',16.99]
    ]},
    {g:'1.56 — Photo Blue Blocker AR', items:[
      ['1.56 Photo Blue Blocker AR','+6.00 to -6.00','0.00 to -2.00',13.99],
      ['1.56 Photo Blue Blocker AR EXT','+6.00 to -6.00','0.00 to -4.00',15.59]
    ]},
    {g:'1.59 Polycarbonate — Clear & AR', items:[
      ['1.59 Poly','+6.00 to -8.00','0.00 to -2.00',1.99],
      ['1.59 Poly EXT','+6.00 to -6.00','0.00 to -4.00',3.69],
      ['1.59 Poly AR','+6.00 to -8.00','0.00 to -2.00',2.49],
      ['1.59 Poly AR EXT','+6.00 to -6.00','0.00 to -4.00',4.59]
    ]},
    {g:'1.59 Polycarbonate — Blue Blocker & Photo', items:[
      ['1.59 Poly Blue Blocker AR','+6.00 to -6.00','0.00 to -2.00',6.59],
      ['1.59 Poly Blue Blocker AR EXT','+6.00 to -8.00','0.00 to -4.00',9.99],
      ['1.59 Poly Photo Grey AR','+6.00 to -6.00','0.00 to -2.00',14.99],
      ['1.59 Poly Photo Grey AR EXT','+6.00 to -6.00','0.00 to -4.00',19.59]
    ]},
    {g:'1.67 Hi-Index — Standard & AR', items:[
      ['1.67 Hi-Index','+6.00 to -12.00','0.00 to -2.00',10.59],
      ['1.67 Hi-Index EXT','+6.00 to -10.00','-2.25 to -4.00',12.99],
      ['1.67 AR Hi-Index','+6.00 to -12.00','0.00 to -2.00',13.99],
      ['1.67 AR Hi-Index EXT','+6.00 to -10.00','-2.25 to -4.00',16.59]
    ]},
    {g:'1.67 Hi-Index — Blue Blocker & Photo', items:[
      ['1.67 Blue Blocker AR','+6.00 to -12.00','0.00 to -2.00',24.59],
      ['1.67 Blue Blocker AR EXT','+6.00 to -10.00','0.00 to -4.00',34.99],
      ['1.67 Photo Grey AR','+6.00 to -10.00','0.00 to -2.00',34.99],
      ['1.67 Blue Blocker Photo Grey AR','+6.00 to -10.00','0.00 to -2.00',44.99]
    ]},
    {g:'1.74 Hi-Index — AR & Blue Blocker', items:[
      ['1.74 AR','+6.00 to -12.00','0.00 to -2.00',25.99],
      ['1.74 Blue Blocker AR','+6.00 to -12.00','0.00 to -2.00',34.99]
    ]}
  ];

  // ============ HELPERS for generating Rx selects ============
  window.LO_genRange = function(low, high, step, prefix){
    prefix = prefix || '';
    var arr = [];
    for(var v=low; v<=high+0.0001; v+=step){
      var s = (v>=0?'+':'') + v.toFixed(2);
      arr.push(prefix+s);
    }
    return arr;
  };

  window.LO_makeSelect = function(name, values, opts){
    opts = opts || {};
    var s = '<select name="'+name+'"';
    if(opts.id) s += ' id="'+opts.id+'"';
    if(opts.onchange) s += ' onchange="'+opts.onchange+'"';
    s += '>';
    s += '<option value="">'+(opts.placeholder||'—')+'</option>';
    values.forEach(function(v){
      if(Array.isArray(v)) s += '<option value="'+v[0]+'">'+v[1]+'</option>';
      else s += '<option value="'+v+'">'+v+'</option>';
    });
    s += '</select>';
    return s;
  };

  window.LO_money = function(n){
    if(n===0||n==='0') return '$0.00';
    if(!n||isNaN(n)) return '—';
    return '$' + Number(n).toFixed(2);
  };

})();
